import signOutDialog from './sign-out-dialog.json';
import notifications from './notifications.json';

export default {
  'nav-bar': {
    'sign-out-dialog': signOutDialog,
    ...notifications,
  },
};
